// src/utils/transformConfig.ts
import { Category } from "../types/reportTypes";

export const transformReportConfig = (config: any[]): Category[] => {
  return config.map((category) => ({
    CategoryCode: category.CategoryCode || "",
    Name: category.Name,
    Title: category.Title,
    Description: category.Description,
    Type: category.Type,
    Parent: category.Parent,
    ReportCode: category.ReportCode,
    scope: category.scope,
    children: category.children
      ? category.children.map((report: any) => ({
          ReportCode: report.ReportCode,
          Name: report.Name,
          Description: report.Description,
          IsActive: report.IsActive,
          Type: report.Type,
          CategoryCode: report.CategoryCode,
          ContentType: report.ContentType,
          Permission: report.Permission,
          scope: report.scope,
          parameters: report.Metadata?.parameters || [], // Map Metadata.parameters to Report.parameters
          metadataCategory: report.Metadata?.metadataCategory || [],
          apiUrls: report.Metadata?.apiUrls || [],
          Metadata: report.Metadata || {},
          children: report.children,
        }))
      : [],
  }));
};
